var _circle, _circle2, _rect, _path, _path2, _path3, _path4, _g, _g2, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.833,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#FCD1C1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.833,
    cy: 32,
    r: 28,
    fill: "#FCD1C1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.833,
    y: 40,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F46530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3333 49.3867V51.2934L51.6599 51.0601C51.3199 50.9401 51.1133 50.8267 51.1133 50.2467C51.1133 49.7734 51.4666 49.3867 51.8999 49.3867H52.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.553 53.7537C54.553 54.227 54.1997 54.6137 53.7663 54.6137H53.333V52.707L54.0063 52.9404C54.3463 53.0604 54.553 53.1737 54.553 53.7537Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.626 45.334H50.0393C47.6127 45.334 46.166 46.7807 46.166 49.2073V54.794C46.166 57.2207 47.6127 58.6673 50.0393 58.6673H55.626C58.0527 58.6673 59.4993 57.2207 59.4993 54.794V49.2073C59.4993 46.7807 58.0527 45.334 55.626 45.334ZM54.3393 52.0007C54.8593 52.1807 55.5527 52.5607 55.5527 53.754C55.5527 54.7807 54.7527 55.614 53.766 55.614H53.3327V56.0007C53.3327 56.274 53.106 56.5007 52.8327 56.5007C52.5593 56.5007 52.3327 56.274 52.3327 56.0007V55.614H52.0927C50.9993 55.614 50.1127 54.6873 50.1127 53.554C50.1127 53.2807 50.3327 53.054 50.6127 53.054C50.886 53.054 51.1127 53.2807 51.1127 53.554C51.1127 54.1407 51.5527 54.614 52.0927 54.614H52.3327V52.354L51.326 52.0007C50.806 51.8207 50.1127 51.4407 50.1127 50.2473C50.1127 49.2207 50.9127 48.3873 51.8993 48.3873H52.3327V48.0007C52.3327 47.7273 52.5593 47.5007 52.8327 47.5007C53.106 47.5007 53.3327 47.7273 53.3327 48.0007V48.3873H53.5727C54.666 48.3873 55.5527 49.314 55.5527 50.4473C55.5527 50.7207 55.3327 50.9473 55.0527 50.9473C54.7793 50.9473 54.5527 50.7207 54.5527 50.4473C54.5527 49.8607 54.1127 49.3873 53.5727 49.3873H53.3327V51.6473L54.3393 52.0007Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8333 44L46.1667 34.6667H40.8467L40.8333 20H24.8333V34.6667H19.5L32.8333 44Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_13606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.833 34.666L36.833 26.666",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_164_13606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 27.9993C29.8679 27.9993 30.1663 27.7009 30.1663 27.3327C30.1663 26.9645 29.8679 26.666 29.4997 26.666C29.1315 26.666 28.833 26.9645 28.833 27.3327C28.833 27.7009 29.1315 27.9993 29.4997 27.9993Z",
    fill: "#F46530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 27.9993C29.8679 27.9993 30.1663 27.7009 30.1663 27.3327C30.1663 26.9645 29.8679 26.666 29.4997 26.666C29.1315 26.666 28.833 26.9645 28.833 27.3327C28.833 27.7009 29.1315 27.9993 29.4997 27.9993Z",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 34.6673C36.5349 34.6673 36.8333 34.3688 36.8333 34.0007C36.8333 33.6325 36.5349 33.334 36.1667 33.334C35.7985 33.334 35.5 33.6325 35.5 34.0007C35.5 34.3688 35.7985 34.6673 36.1667 34.6673Z",
    fill: "#F46530",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_13606",
    x: 25.833,
    y: 23.666,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_13606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_13606",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_164_13606",
    x: 25.833,
    y: 23.666,
    width: 11.333,
    height: 11.334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_13606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_13606",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrors);
export default __webpack_public_path__ + "static/media/mirrors.167178184244556556fd720452ed3de1.svg";
export { ForwardRef as ReactComponent };